import 'modern-normalize/modern-normalize.css';
import '@ingka/accordion/dist/style.min.css';
import '@ingka/aspect-ratio-box/dist/style.min.css';
import '@ingka/button/dist/style.min.css';
import '@ingka/card/dist/style.min.css';
import '@ingka/carousel/dist/style.min.css';
import '@ingka/choice/dist/style.min.css';
import '@ingka/compact-card/dist/style.min.css';
import '@ingka/expander/dist/style.min.css';
import '@ingka/focus/dist/style.min.css';
import '@ingka/forms/dist/style.min.css';
import '@ingka/hyperlink/dist/style.min.css';
import '@ingka/image/dist/style.min.css';
import '@ingka/inline-message/dist/style.min.css';
import '@ingka/list-view/dist/style.min.css';
import '@ingka/list/dist/style.min.css';
import '@ingka/loading/dist/style.min.css';
import '@ingka/modal/dist/style.min.css';
import '@ingka/price/dist/style.min.css';
import '@ingka/simple-video/dist/style.min.css';
import '@ingka/skeleton/dist/style.min.css';
import '@ingka/slider/dist/style.min.css';
import '@ingka/svg-icon/dist/style.min.css';
import '@ingka/switch/dist/style.min.css';
import '@ingka/text/dist/style.min.css';
import '@ingka/toast/dist/style.min.css';
import '@ingka/toggle/dist/style.min.css';
import '@ingka/tooltip/dist/style.min.css';
import '@ingka/variables/dist/style.min.css';
import '@ingka/grid/dist/style.min.css';
import { createGlobalStyle } from 'styled-components';
import { COLORS } from 'utils/constants/colors';
import { fontSize } from 'utils/constants/style';

const GlobalStyles = createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
  }

  html {
    box-sizing: border-box;
    touch-action: pan-x pan-y;
    scroll-behavior: smooth;
    font-size: ${fontSize}px;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
    -webkit-tap-highlight-color: transparent;
    font-family: var(--ikea-font);
  }

  body {
    min-height: 100vh;
    min-height: fill-available;
    overscroll-behavior-y: none;
    -webkit-font-smoothing: antialiased;
    -webkit-touch-callout: none !important;
    overflow: hidden;
  }

  #root {
    min-height: 100%;
    min-width: 100%;
    height: 100%;
    overflow-y: auto;
    
  }

  // Skapa button have a fluid attribute that doest the same thing. So I think we can keep this until we switch to those or this is a good time to do so.
  .width-full {
    width: 100%;
  }

  .choice-item button {
    cursor: pointer;
  }

  a {
    color: initial;
    text-decoration: none;
    cursor: pointer;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
  }

  ul {
    padding: 0;
  }
  
  .unstyled-list {
    padding: 0;
    list-style-type: none;
  }

  p, a {
    margin: 0;
  }

  #intro, #guide, #planner, #summary {
    outline: none;
    overflow: hidden;
  }

  body.hovered {
    cursor: pointer;
  }
  
  body.hovered.dragging {
    cursor: grabbing;
  }

  :where([aria-disabled="true" i], [disabled]) {
    cursor: default;
  }

  @media print {
    #root, [aria-modal="true"]{
      display: none;
    }
  }

  /**
  * Same z-index as Kompis. Temporary until Kompis migrate to SKAPA sheets.
  * Original value: 400
  * We do this to make sure our missing panels modal is visible when summarys own modal is shown. 
  * Summary built in modal is not working properly when there is no content available in productData.
  */
  .modal-wrapper {
    z-index: 500;
  }

  .gallery-item-fixed-size {    
    width: 16rem;
    margin-inline: 0
  }

  #webglContext {
    opacity: 0;
    visibility: hidden;
  }

  .greenCard {
    background-color: ${COLORS.CARD_GREEN};
  }
  .grayCard {
    background-color: ${COLORS.BACKGROUND_LIGHTGRAY}
  }

  .columnReverse {
    flex-direction: column-reverse !important;
  }
  
  .columnReverse .content-card__title {
    font-size: 1.125rem;
  }

  .card .content-card {
    padding: 2rem !important;
  }

  [data-rsbs-header] {
    padding-top: 0;
    padding-bottom: 0;
  }

  [data-rsbs-backdrop] {
    display: none;
  }

  /**
  * Ingka variables
  * LINK - https://react.skapa.ikea.net/?path=/docs/content-divider--documentation
  */
  hr {
    border: none;
    border-top: 1px solid rgba(0, 0, 0, 0);
    border-right: 1px solid rgba(0, 0, 0, 0);
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
    background: rgb(var(--colour-neutral-3, 223, 223, 223));
    height: auto;
}

.list-view-item--disabled .list-view-item__action, .list-view-item--disabled .list-view-item__default, .list-view-item--disabled .list-view-item__description, .list-view-item--disabled .list-view-item__icon-center, .list-view-item--disabled .list-view-item__icon-top, .list-view-item--disabled .list-view-item__quantity-label, .list-view-item--disabled .list-view-item__title {
    color: #757575;
}
`;

export default GlobalStyles;
